import React from 'react';
import { View } from 'react-native';

import Slider from '@react-native-community/slider';
import PropTypes from 'prop-types';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { Images } from '../../Themes';

import styles from './Video.Styles';

const Scrubber = ({ progress, onSeek, onSeekRelease }) => {
  return (
    <View style={styles.container}>
      <Slider
        style={styles.slider}
        onValueChange={onSeek}
        onSlidingComplete={onSeekRelease}
        value={progress}
        minimumTrackTintColor={Colors.white}
        maximumTrackTintColor={Colors.whiteRGBA(0.5)}
        thumbImage={Images.ic_slider_thumb}
      />
    </View>
  );
};

Scrubber.propTypes = {
  onSeek: PropTypes.func.isRequired,
  onSeekRelease: PropTypes.func.isRequired,
  progress: PropTypes.number.isRequired,
};

export default Scrubber;
